import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-turns-appointments-card',
  templateUrl: './turns-appointments-card.component.html',
  styleUrls: ['./turns-appointments-card.component.scss']
})
export class TurnsAppointmentsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('appointments-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('appointments-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.length;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('appointments-counts-spinner');
    }
  }
}
